import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

// Место блока, который грузится: той же формы, с бегущим бликом. Без анимации — если
// в системе просят меньше движения.
export const Skeleton = ({ className, ...props }: ComponentProps<"div">) => (
  <div
    data-slot="skeleton"
    aria-hidden="true"
    className={cn(
      "animate-shimmer rounded-md bg-surface-raised bg-shimmer motion-reduce:animate-none",
      className,
    )}
    {...props}
  />
);
